import {
  GetInstallationPlansDocument,
  GetInstallationPlansQuery,
  SaveInstallation_Input,
  SaveInstallationMutation,
  useGetInstallationPlansQuery,
  useSaveInstallationMutation
} from 'generated/graphql';
import { DateTime } from 'luxon';
import { gqlCacheUtil } from 'modules/common';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  uploadedBy: string;
  planSetName: string;
  numberOfVersions: number;
  createdDate: DateTime;
  updatedDate: DateTime;
  imgUrl: string;
}

export function useQuery(id: string) {
  const tuple = useGetInstallationPlansQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const plan = tuple.data?.installation?.plan;

      const data: IData = {
        id: plan?.id ?? '',
        createdDate: plan?.createdDate ?? DateTime.now(),
        name: plan?.name ?? '',
        uploadedBy: plan?.versions[0]?.uploadedBy.fullName ?? '',
        numberOfVersions: plan?.versions.length ?? 0,
        planSetName: plan?.planSet.displayName ?? '',
        updatedDate: plan?.createdDate ?? DateTime.now(),
        imgUrl: ''
      };
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}


export function useRemoveInstallationPlan() {
  const [
    fnMutate,
    tuple
  ] = useSaveInstallationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SaveInstallation_Input) => {
      await fnMutate({
        variables: {
          input: {
            id: input.id,
            planId: null
          }
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<GetInstallationPlansQuery, SaveInstallationMutation>(GetInstallationPlansDocument, (prevState, {}) => {
            if (!prevState.installation) {
              return prevState;
            }
            return {
              ...prevState,
              installation: {
                ...prevState.installation,
                plan: null
              }
            };
          })
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
